import { Col } from 'antd';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { useThemeComponents } from '../../../themes';
import colSpan from '../../shared/ApplicationDetailsPage/standard/colSpan';
import ApplicationDetailsPanel from '../../shared/ApplicationDetailsPage/standard/Panel';
import SectionKey from '../../shared/ApplicationDetailsPage/standard/SectionKey';
import { type TradeInApplicationFormValues } from './TradeInForm';

const TradeInMainPanel = ({ updated, offset }: { updated: string; offset: string }) => {
    const { t } = useTranslation(['tradeInDetails', 'tradeInList']);
    const { FormFields } = useThemeComponents();

    const { values } = useFormikContext<TradeInApplicationFormValues>();

    return (
        <ApplicationDetailsPanel
            header={t('tradeInDetails:panels.application.main.header')}
            name={SectionKey.MainDetails}
            defaultExpanded
        >
            <Col {...colSpan}>
                <FormFields.DisplayField
                    {...t('tradeInDetails:fields.identifier', { returnObjects: true })}
                    value={values.identifier ?? ''}
                    disabled
                />
            </Col>

            <Col {...colSpan}>
                <FormFields.DisplayField
                    {...t('tradeInDetails:fields.status', { returnObjects: true })}
                    value={t(`tradeInList:status.${values.status}`)}
                />
            </Col>

            <Col {...colSpan}>
                <FormFields.DatePickerField
                    {...t('tradeInDetails:fields.createdAt', { returnObjects: true })}
                    name="versioning.createdAt"
                    picker="date"
                    disabled
                    required
                />
            </Col>

            <Col {...colSpan}>
                <FormFields.DisplayFieldWithUTCOffset
                    {...t('tradeInDetails:fields.updatedAt', { returnObjects: true, offset })}
                    value={updated}
                />
            </Col>
        </ApplicationDetailsPanel>
    );
};

export default TradeInMainPanel;
